// extracted by mini-css-extract-plugin
export default {"close":"modalbox_close__dHSok","text":"modalbox_text__9M4cC","header":"modalbox_header__8M+FN"};